import {NewTaskItem} from "../../../redux/Task/Task/reducer";
import {PeerActivityType} from "../../../redux/Content/PeerActivity/types";
import {TaskType} from "../../../redux/Task/Task/types";
import {handleTaskEdit} from "../../Task/Task/TaskActions";
import {MessengerMessageType} from "../../../redux/Messenger/Chat/types";


export const handleCreateNewTaskByMessage = (entity: MessengerMessageType, dispatch: any) => {
    let newTask:TaskType = NewTaskItem;

    newTask = {
        ...newTask,
        text: entity?.text && entity.text
    }

    handleTaskEdit(newTask, dispatch);
}